<template>
    <div>
        <hero></hero>

        <section class="section bg-secondary">
            <div class="container">
                <div class="row text-center justify-content-center">
                    <!-- <div class="col-lg-10"> -->
                    <!-- <h2 class="display-3">Build something</h2> -->
                    <p class="lead">MemX defines wearable and interactive AGI, a unification of wearable technology and
                        artificial general intelligence (AGI), MemX aims to advance the human-centered computing pathway
                        from human perception, emotion, cognition, and finally, also hopefully, towards human-centered
                        AGI.</p>
                    <!-- </div> -->
                </div>
            </div>
        </section>


        

        <section class="section section-lg">
            <div class="container">

                <div class="row">
                    <div class="mb-5">
                        <h2>Research Blog</h2>
                        <p class="font-weight-500">Some cool research</p>
                    </div>

                <div class="row">
                        <div class="col-sm-6 py-3">
                            <h2 class="font-weight-bold">Buddie</h2>
                            
                            <p style="font-weight: bold;">
                                Buddie 是由MemX团队打造的情境感知 AI 耳机，重新定义智能音频交互体验。它与手机应用协同运作，凭借全天候情境感知功能，能实时捕捉环境对话与用户请求，基于 AI 技术精准响应，例如会议中快速抓取关键信息，让沟通更高效。我们相信，在人工智能时代，语音将成为下一个具有变革性的交互界面，而具备情境感知功能的耳机拥有理想的外形 —— 能让人随时随地无需动手，轻松使用人工智能服务。
                            </p>
                            <h5 class="mt-4">核心功能：</h5>
                            <ul>
                                <li>实时转录：在电话通话、在线会议及面对面讨论场景中，Buddie 能持续进行转录，基于上下文理解，回答有关会议和生活方面的问题。
                                </li>
                                <li>会议支持：会议期间提供隐秘提示，总结行动事项和要点，辅助用户高效参与会议。
                                </li>
                                <li>免手动交互：无需拿起手机或按按钮，借助前沿大语言模型（如 ChatGPT），实现轻松的语音交互。
                                </li>
                                <li>个性化协助：倾听并了解用户偏好，提供定制化建议，回顾日常生活中值得铭记的时刻 。
                                </li>
                            </ul>

                           
                        </div>
                        <div class="col-sm-6">
                            <img src="/memx-website/img/research_blog/buddie.jpg"
                                alt="Your Image"
                                style="width: 400px; height: 400px; object-fit:cover; margin-top: 25px;">
                            <div class="row" style="margin-top: 40px;">
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Jiangli_Huang.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Jiangli Huang</h7>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Wentao_Pan.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Wentao Pan</h7>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Yifei_Feng.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Yifei Feng</h7>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 100px;" >
                        <div class="col-sm-6">
                            <img src="/memx-website/img/research_blog/Memx.png"
                                alt="Your Image"
                                style="width: 390px; height: 500px; object-fit:cover; margin-top: 20px;">
                            <div class="row" style="margin-top: 40px;">
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Zhenyu_Xu.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Zhenyu Xu</h7>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Zhouyang_Lu.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Zhouyang Lu</h7>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Hailin_Xu.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Hailin Xu</h7>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 py-3">
                            <h2 class="font-weight-bold">Memx-"Hello, Samantha"</h2>
                            <h5 class="mt-4">穿戴式的通用人工智能：</h5>
                            <p style="font-weight: bold;">
                                它是一副智能眼镜、是一个小小的别针；它也是你的知心朋友、你的情感导师、你的得力助手，是你的玩伴、“僚机”、健身搭子……它融入你的24小时，共享你的视角、倾听你的声音、共鸣你的心跳。它记录着你的生活、共享着你的悲喜、见证着你的成长。它既是电影"Her"中温情的的灵魂伴侣
                                Samantha、也是电影 "Ironman" 中无往不胜的智能管家
                                JARVIS。它是大模型和穿戴式智能硬件的结合，它将通用人工智能(AGI)真正融入日常，它让科幻成为生活的一部分。</p>

                            <h5 class="mt-4">核心功能：</h5>
                            <ul>
                                <li>实时多模态理解：汇聚穿戴设备的视听流，实时解码周遭世界，捕捉每一个动作细节，将每一句低语转译为文字，让沟通无界限。</li>
                                <li>智能记忆库：珍藏与你的每一次互动，像最贴心的日记本，随时唤醒那些值得铭记的瞬间，伴随你一同成长，共创精彩记忆。</li>
                                <li>对话 Agent：管理多维度信息与记忆，进行深度推理与行动响应，以流畅的语音交流，成为你日常生活中的智慧顾问。</li>
                            </ul>

                            <h5 class="mt-4">技术支持：</h5>
                            <ul>
                                <p>智能眼镜硬件平台、AI Pin 硬件平台、视觉语言模型、大语言模型、向量数据库、Agent 设计</p>
                            </ul>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 100px;">
                        <div class="col-sm-6 py-3">
                            <h2 class="font-weight-bold">机器学习系统</h2>
                            
                            <p style="font-weight: bold;">
                                据时代的 Hadoop 浪潮。我们实验室以大模型为核心，自顶向下探索全新的计算机系统软硬件平台技术，涵盖机器学习编译与优化、并行训练框架、推理优化框架以及 AI 处理器设计等前沿领域。这一研究深度融合计算机系统架构与深度学习知识，旨在构建高效、稳定、可扩展的机器学习系统，为科研机构和企业开辟广阔的创新空间与就业前景。我们深入剖析大模型的学习机理，聚焦训练过程中的稳定性、计算复杂度和高效性问题，探索模型在与人与世界交互中实现一学就会、触类旁通、永不遗忘、无师自通的学习新范式。同时，我们致力于端侧个性化小模型技术，通过模型压缩、低精度量化和系统级优化，将大模型的强大能力迁移到资源受限的边缘设备，满足多样化的应用场景需求。
                            </p>
                            <h5 class="mt-4">核心功能：</h5>
                            <ul>
                                <li>高效稳定的训练范式：通过创新的训练方法，规避超参数、数据异常和算子不稳定等问题，确保模型稳定收敛。采用低精度量化策略显著降低训练运算开销，同时压缩模型规模，使其适配端侧设备部署，兼顾高效性和资源友好性。
                                </li>
                                <li>个性化持续学习能力：通过动态调整模型结构并基于数据表征进行智能分发，确保不同领域数据的表征在训练中互不干扰，避免知识遗忘。模型支持持续学习，适应用户个性化场景，持续优化以满足特定需求。
                                </li>
                                <li>系统级训练与推理优化：在系统和框架层面优化算子性能，针对分布式训练和推理场景进行内存调度与算子调度优化。无论在云端还是端侧，均实现高效的计算资源利用，显著提升训练与推理性能。
                                </li>
                            </ul>

                            <h5 class="mt-4">理论支撑：</h5>
                            <ul>
                                <p>模模型可解释理论，数值稳定性，优化理论，表征学习，深度学习编译器，并行理论，算子优化</p>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <img src="/memx-website/img/research_blog/Optimization.png"
                                alt="Your Image"
                                style="width: 400px; height: 400px; object-fit:cover; margin-top: 25px;">
                            <div class="row" style="margin-top: 40px;">
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Hengjie_Cao.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Hengjie Cao</h7>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Yifeng_Yang.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Yifeng Yang</h7>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Mengyi_Chen.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Mengyi Chen</h7>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 100px;">
                        <div class="col-sm-6">
                            <img src="/memx-website/img/research_blog/xitong.png"
                                alt="Your Image"
                                style="width: 400px; height: 400px; object-fit:cover; margin-top: 25px;">
                            <div class="row" style="margin-top: 40px;">
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Hailin_Xu.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Hailin Xu</h7>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Siyuan_Tang.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Siyuan Tang</h7>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Junyi_Zhang.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Junyi Zhang</h7>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 py-3">
                            <h2 class="font-weight-bold">Automated Generation of Intelligent Embedded Systems</h2>
                            <h5 class="mt-4">大模型驱动的智能嵌入式系统自动化生成：</h5>
                            <p style="font-weight: bold;">
                                智能嵌入式系统例如具身智能机器人、智能可穿戴设备正在迅速改变人们的生活。我们致力于探索智能嵌入式系统开发迈向 "自动驾驶" 时代，通过大模型技术重塑嵌入式系统软硬件设计流程，代码自动生成，探索智能高效的系统自动化生成新范式。团队专注研发具备自主学习能力的嵌入式系统开发平台，目标是实现设计、编码、调试和测试全流程的系统自动化设计与实现。
                            </p>

                            <h5 class="mt-4">核心功能：</h5>
                            <ul>
                                <li>知识学习与组织 ：系统自动学习并组织知识，为决策和行为提供坚实基础.</li>
                                <li>任务分解与执行 ：自动分解任务并高效执行，确保任务顺利完成.</li>
                                <li>经验积累与进化 ：通过积累经验实现自我进化，适应新环境和需求变化。</li>
                            </ul>

                            <h5 class="mt-4">技术支持：</h5>
                            <ul>
                                <p>大语言模型、检索增强生成、自主智能体</p>
                            </ul>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 100px;">
                        <div class="col-sm-6 py-3">
                            <h2 class="font-weight-bold">开源机器人</h2>
                            
                            <p style="font-weight: bold;">这是带领初学者探索机器人世界的理想起点。这款身高50厘米的灵巧机器人，麻雀虽小却五脏俱全。它具备视觉感知能力，能捕捉周围环境；拥有听觉系统，可识别声音讯号；更能通过拟人化动作和语音交互与环境互动。
                            </p>
                            <h5 class="mt-4">核心功能：</h5>
                            <ul>
                                
                                <li>在这个成长计划中，我们将与陪伴机器人共同进化：我们将教会它从蹒跚学步到翩然起舞，从基础抓取到精准操作，从简单问候到情感化交流。随着项目推进，我们将持续升级它的机械结构与硬件系统，完善它对多模态物理世界的感知能力，训练它在和人与世界的交互中不断学习。我们的终极愿景，是打造真正懂你的个性化生活伙伴——它会记住每个交互对象的习惯，适应不同物理环境，并最终成为独一无二的陪伴者。
                                </li>
                            </ul>

                           
                        </div>
                        <div class="col-sm-6">
                            <img src="/memx-website/img/research_blog/Q-Agent_RB.png"
                                alt="Your Image"
                                style="width: 400px; height: 400px; object-fit:cover; margin-top: 25px;">
                            <div class="row" style="margin-top: 40px;">
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Zhenyu_Xu.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Zhenyu Xu</h7>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Lexuan_Qian.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Lexuan Qian</h7>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Chenyu_Gan.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Chenyu Gan</h7>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>


                    <div class="row" style="margin-top: 100px;">
                        <div class="col-sm-6">
                            <img src="/memx-website/img/research_blog/Video Generation.jpg"
                                alt="Your Image"
                                style="width: 400px; height: 400px; object-fit:cover; margin-top: 25px;">
                            <div class="row" style="margin-top: 40px;">
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Chenyu_Wang.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Chenyu Wang</h7>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Shuo_Yan.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Shuo Yan</h7>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Lexuan_Qian.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Lexuan Qian</h7>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Shiying_Liu.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Shiying Liu</h7>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div class="col-sm-6 py-3">
                            <h2 class="font-weight-bold">Video Generation</h2>
                            <h5 class="mt-4">卡通智能生成工具：</h5>
                            <p style="font-weight: bold;">
                                它不仅是一个APP，它是你的幻想助手、你的创意伙伴、你的个性化导演。它集成了尖端的AI技术，从语音到屏幕，将你天马行空想象力转化为触手可及的视觉故事。它是你的创意播放器，你的动画制作团队，你的故事讲述者。它融入你的创作过程，给你最简洁直接的操作，同时又提供最大的创作自由。它记录你的灵感，共享你的创作喜悦，见证你的艺术成长。它是技术与艺术的完美结合，它将创意自由（Creative
                                Freedom）真正融入每一个人的生活，让卡通创作变得前所未有的简单与精彩。</p>

                            <h5 class="mt-4">核心功能：</h5>
                            <ul>
                                <li>实时Text-to-API技术：借助大语言模型强大的知识与逻辑能力，帮助用户优化自己的故事脚本，智能编排，并转化为动画生成器的执行指令，让每个想法的火花都能无障碍转化成动画作品。
                                </li>
                                <li>高质量视频生成：利用扩散模型技术生成高质量的视频素材，让你的卡通角色跃然屏幕，让每一次创作都是一次视觉的享受。</li>
                                <li>视觉动作解耦算法：允许用户随心所欲地个性化定制角色、道具和背景，实现高度个性化的创作需求，精准表达心中的想象。</li>
                            </ul>

                            <h5 class="mt-4">技术支持：</h5>
                            <ul>
                                <p>大语言模型、Text-to-API技术、扩散模型、视觉动作表征解耦算法模型、交互界面设计</p>
                            </ul>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 100px;">
                        <div class="col-sm-6 py-3">
                            <h2 class="font-weight-bold">Collect musical inspiration anytime, anywhere</h2>
                            <h5 class="mt-4">音乐生成人工智能：</h5>
                            <p style="font-weight: bold;">发现音乐的无限可能，创作不再是专业人士的专属领域。
                                无论是你偶尔脑海里浮现的旋律，还是在城市的喧嚣中听到的节奏，亦或是在自然风景中感受到的静谧，都能激发出你独特的音乐创作灵感。音乐生成人工智能将你的想象力转化为现实，让你用音乐来述说自己的生活、表达内心的情感。探索新时代人与音乐的紧密关系。让音乐创作变得更加自然，成为最直接的情感表达方式。
                            </p>
                            <h5 class="mt-4">核心功能：</h5>
                            <ul>
                                <li>音乐灵感收集：汇集各种音乐来源，包括听觉、视觉等多种模态，捕捉你生活中的每一个音符，每一个情感波动，让你的创作灵感无处不在。
                                </li>
                                <li>智能创作助手：结合先进的音乐分析技术和机器学习算法，为你提供个性化的创作建议和混音方案，助你轻松创作出独具风格的音乐作品。
                                </li>
                                <li>实时反馈与互动：即时解码音乐元素，捕捉音乐的重复模式和节奏，为你提供实时的反馈和互动，让创作过程更加流畅、直观。
                                </li>
                                <li>音乐人格存储：记录每一次创作过程和互动，形成个性化的音乐记忆库，随时唤醒你的创作灵感，让你与音乐创作模型一同成长，共同创造精彩的音乐历程。
                                </li>
                            </ul>

                            <h5 class="mt-4">技术支持：</h5>
                            <ul>
                                <p>生成模型、向量数据库、音乐信息检索、音频编解码器</p>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <img src="/memx-website/img/research_blog/Music.jpg"
                                alt="Your Image"
                                style="width: 400px; height: 400px; object-fit:cover; margin-top: 25px;">
                            <div class="row" style="margin-top: 40px;">
                                <div class="col-md-6 col-lg-3 mb-3">
                                    <img v-lazy="'/memx-website/img/photos/Guojie_Zhao.jpg'"
                                        class="img-fluid rounded-circle shadow-lg"
                                        style="width: 150px; height: 150px; object-fit: cover;">
                                    <div class="pt-2 text-center">
                                        <h7>Guojie Zhao</h7>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    

                </div>
            </div>
        </section>


    </div>
</template>

<script>
import Hero from "./components/Hero";
import Products from "./components/Products";

export default {
    name: "home",
    components: {
        Hero,
        Products
    },
    data: () => {
        return {
            name: '',
            contact: '',
            message: '',
            tip: 'Place Order',
            pj_show_idx: 0,
            pj_idx: 0,
            pj_content: [
                '<p>MemX是世界上第一个智能眼镜与大语言模型（LLM）相结合的可穿戴AGI。在理解用户“认知-情感-行为”的基础上，MemX融合可穿戴技术（AR/VR）与通用人工智能技术（AGI），研究并实现以人为中心的通用智能可穿戴系统。主要研究内容包括面向移动端的视觉-语言模型、基于LLM的个性化AGI、低功耗的深度学习技术、智能可穿戴式设备的设计以及参与式系统评估方法等，实现个性化、智能化的人机交互体验，探索面向认知-情感的个性化通用智能服务。戴上MemX，她可以见你所见、听你所听、感你所感，成为我们横跨虚拟世界与物理世界的精神伴侣。</p>',
                '<p>深度学习大模型的发展对计算机软硬件系统提供了全新的机遇。类比大数据时代的Hadoop，面向深度学习大模型，我们需要从模型开始，自顶至下构建全新的计算机系统软硬件平台技术。具体研究方向包括，面向大模型的向量数据存储技术，面向1,000-10,000计算节点的分布式大模型训练框架，深度学习编译器，以及AI处理器体系结构。这个领域的科研需要结合计算机系统的知识与深度学习的知识。就业方向包括致力于大模型的科研院所、互联网企业与IT企业。</p>',
                '<p>本课题致力于利用大模型技术开发一个高度先进的通用人工智能系统——Q智能体。该系统不仅能够理解和执行广泛的任务，而且能够自我学习和适应，持续不断地提升自身的智能。Q智能体的设计理念基于一个核心目标：创建一个能够跨越多个领域、解决各种问题并与人类以及其他智能系统自然协作的AGI系统。通过集成和优化当前的大模型技术，Q智能体将能够在理解自然语言、视觉识别、策略规划等多个方面展现出超越现有技术的能力。本课题团队由来自不同背景但共同致力于人工智能未来发展的老师和同学们组成，欢迎对该课题感兴趣的同学加入我们，共同探索这一充满挑战和机遇的新领域。</p>',
            ]
        }
    },
    mounted() {

        // 首次加载时,需要调用一次
        this.screenWidth = window.innerWidth;
        this.setSize();

        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == "research") {
                this.show_details = false;
                this.pj_show_idx = pair[1] - 1;
                this.pj_idx = pair[1] - 1;
            }
        }


        // 窗口大小发生改变时,调用一次
        window.onresize = () => {
            this.screenWidth = window.innerWidth;
            this.setSize();
        }

        this.$nextTick(function () {
            if ('/works' === this.$route.path || '/products' === this.$route.path) {
                // console.log(this.$route.path)
                const ref = this.$route.path.replace('/', '#')
                const el = document.querySelector(ref)
                if (el) {
                    el.scrollIntoView(true)
                    //   el.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
                }
            }
        })
    },
    methods: {
        showDetails(event) {
            this.show_details = false
            if (event.target.id == 'pj1') {
                this.pj_idx = 0
            }
            else if (event.target.id == 'pj2')
                this.pj_idx = 1
            else if (event.target.id == 'pj3')
                this.pj_idx = 2
            else if (event.target.id == 'pj4')
                this.pj_idx = 3
            else this.pj_idx = 4
            // this.show_details = true
            this.pj_show_idx = this.pj_idx
        },
        closeDetails() {

        },
        setSize() {
            // 通过浏览器宽度(图片宽度)计算高度
            this.bannerHeight = 777 / 1920 * this.screenWidth
            this.headHeight = this.bannerHeight * 0.24
            this.rearHeight = this.bannerHeight * 0.37
        },

        submit: function (event) {
            if (!this.name) {
                this.tip = 'Please enter your name and send again'
            } else if (!this.contact) {
                this.tip = 'Please enter your contact and send again'
            } else if (!this.message) {
                this.tip = 'Please enter message and send again'
            } else {
                this.tip = 'Placing...'
                const AV = require('leancloud-storage');
                const { Query, User } = AV;
                AV.init({
                    appId: "tQNLSFWLEcr2otLmMbz7vvUP-gzGzoHsz",
                    appKey: "4s6pmNW3L1jizoK2YRag7aqk",
                    serverURL: "https://tqnlsfwl.lc-cn-n1-shared.com"
                });
                const Message = AV.Object.extend('Message');
                const message = new Message();
                message.set('name', this.name);
                message.set('contact', this.contact);
                message.set('message', this.message);
                message.save().then((message) => {
                    this.tip = 'Placed successfully'
                })
            }
        }

    }
};
</script>

<style>
.section {
    padding: 50px 0;
    /* Adjust padding as needed */
}

.container {
    display: flex;
    justify-content: center;
}

.row {
    display: flex;
}

.research_card {
    width: 300px;
    height: 550px;
    margin: 0 20px;
    border-radius: 10px;
    overflow: hidden;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.research_card:hover {
    transform: scale(1.05);
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
}

@media screen and (max-width: 768px) {
    .research_card {
        width: 100%;
        height: auto;
        margin: 0 0 20px 0;
    }

    .research_card:hover {
        transform: none;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    }
}

.research_img {
    width: 100%;
    height: 50%;
    object-fit: cover;
    padding: 10px;
}

.small_font_title {
    text-align: center;
    margin-top: 10px;
    font-weight: bold;
    font-size: 1.3rem;
}

.small_font_text {
    text-align: center;
    margin-top: 10px;
    color: #7d7d7f;
    font-size: 1rem;
    line-height: 1.4;
}

.research_text_warpper {
    padding: 40px;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 1020px; /* 设置最大宽度 */
    height: auto;
    margin: 0 auto; /* 居中 */
}

.research_text {
    font-size: 20px;
    font-weight: bold;
}

.text_line_height {
    line-height: 1.6;
    /* 行高 */
}
</style>